import React, { memo } from 'react';
import './_headerTickets.scss';

const HeaderTickets = () => (
  <a
    href='/calendar'
    className='menu__bar__tickets'
    rel={'noopener noreferrer'}
  >
	{/* <p className='headerTicketsTitle'>TICKETS</p> */}
    <div className='headerTickets' id={'buyTicketButton'}>
      {/*<div className='headerTicketsIcon' />*/}
      <span className={'headerTicketsBuy'}>BUY TICKETS</span>
    </div>
  </a>
);

export default memo(HeaderTickets);
